// Used to create bad data submissions on the Nest endpoint POST `/nest/session/bad-data`
import { EventName } from '../offline-events';

export interface CreateBadDataSubmission {
  name: string;
  desc: string;
  startDate: string;
  endDate: string;
  eventName: EventName;
  uploadIDs: number[];
}

export const exampleCreateBadDataSubmission: CreateBadDataSubmission = {
  name: 'Bad Match Rate from Missing Emails',
  desc:
    'Forgot emails and it had a 20% match rate so I redid the upload as AddToCart',
  startDate: '',
  endDate: '',
  eventName: EventName.AddPaymentInfo,
  uploadIDs: [],
};
